"use client"

import { useEffect, useState } from "react"
import { useUbStorefrontState } from "@/store/ubStorefrontState"
import { sendGTMEvent } from "@next/third-parties/google"
import Cookies from "js-cookie"

import { generatePageTypeTrackingData } from "@/lib/gtmTrackingHelper"

export interface PageTrackingClientProps {
  type: string
}

export const isAnonymous = () => {
  const apiToken: string | undefined = Cookies.get("apiToken")
  if (apiToken) {
    return JSON.parse(apiToken).isAnonymous === true
  }
  return true
}

const PageTrackingClient = (props: PageTrackingClientProps) => {
  const [tracked, setTracked] = useState(false)
  const { isB2BCustomer } = useUbStorefrontState()

  useEffect(() => {
    if (!tracked) {
      //console.log("Send Category Tracking")
      sendGTMEvent(generatePageTypeTrackingData(isAnonymous(), isB2BCustomer, "Category"))
      setTracked(true)
    }
  }, [])

  return <span className={"hidden"}>CategoryBrandsSectionTrackingClient</span>
}
export default PageTrackingClient

/*
{
   "user": {
      "loginStatus": "logged-out",
      "type": "B2B"
   },
   "page": {
      "type": "Category"
   }
}
 */
